import { useEffect } from 'react';

const SITE_URL = 'https://pawsitivefuture.org';

/**
 * Points the document's title, description, canonical URL and social tags at one route while it
 * is mounted, and restores the site-wide values from public/index.html when it unmounts. Only
 * tags index.html already declares are touched, so nothing is left behind on the next route.
 */
export const usePageMeta = (title: string, description: string, path: string): void => {
  useEffect(() => {
    const url = `${SITE_URL}${path}`;
    const previousTitle = document.title;
    const restores = (
      [
        ['meta[name="title"]', 'content', title],
        ['meta[name="description"]', 'content', description],
        ['link[rel="canonical"]', 'href', url],
        ['meta[property="og:url"]', 'content', url],
        ['meta[property="og:title"]', 'content', title],
        ['meta[property="og:description"]', 'content', description],
        ['meta[name="twitter:url"]', 'content', url],
        ['meta[name="twitter:title"]', 'content', title],
        ['meta[name="twitter:description"]', 'content', description],
      ] as const
    ).map(([selector, attribute, value]) => {
      const element = document.head.querySelector(selector);
      const previous = element?.getAttribute(attribute);
      element?.setAttribute(attribute, value);
      return () => {
        if (element && previous != null) element.setAttribute(attribute, previous);
      };
    });
    document.title = title;
    return () => {
      document.title = previousTitle;
      restores.forEach((restore) => restore());
    };
  }, [title, description, path]);
};
